// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-3d93a200]:after{content:normal}#main[data-v-3d93a200]{min-height:auto}.ec-success-container[data-v-3d93a200]{align-items:center;display:flex;flex-flow:column;margin-bottom:20px}.ec-success-grid[data-v-3d93a200]{padding:10px}.ec-success-grid--text[data-v-3d93a200]{width:100%;word-wrap:break-word;max-width:700px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
